import React, { useRef, useState, useEffect } from 'react';
import {
  Button,
  Tag,
  message,
  Form,
  Input,
  Modal,
  InputNumber,
  Select,
  Tooltip,
  Radio,
  Space,
  Image,
} from 'antd';
import ProTable from '@ant-design/pro-table';
import {
  effAllRights,
  optionalRevoke,
  userClockNum,
  userClockData,
} from '@/services/userManager';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { guuid } from '@/utils/utils';

const { TextArea } = Input;

const TrainingView = (props) => {
  // eslint-disable-next-line react/prop-types
  const { userId } = props;
  /// 权益信息
  const rightTableRef = useRef();

  const [userClockNumData, setUserClockNumData] = useState({});
  const [clockType, setClockType] = useState(1);

  useEffect(() => {
    // 请求第一页行为路径
    getUserClockNum();
  }, []);

  const rightTableColumns = [
    {
      title: '打卡时间',
      dataIndex: 'clockTime',
    },
    {
      title: '打卡类型',
      dataIndex: 'clockType',
    },
    {
      title: '类型',
      dataIndex: 'type',
    },
    {
      title: '打卡',
      dataIndex: 'clock',
    },
    {
      title: '打卡照片',
      dataIndex: 'clockImgList',
      width: '450px',
      render: (text, record) => {
        let a = [1, 2];
        const { clockImgList } = record;
        if ((clockImgList || []).length == 0) {
          return '-';
        }
        return (
          <Space wrap>
            {clockImgList.map((item) => {
              return (
                <Image
                  src={item}
                  style={{
                    width: 50,
                    height: 50,
                    objectFit: 'cover',
                  }}
                ></Image>
              );
            })}
          </Space>
        );
      },
    },
  ];

  function getUserClockNum() {
    userClockNum({
      requestData: {
        userId: userId,
      },
    }).then(({ data, code, msg }) => {
      if (code === '00000') {
        setUserClockNumData(data || []);
      }
    });
  }

  function onChange(e) {
    setClockType(e.target.value);
    console.log(e);
    getUserClockNum();
    rightTableRef.current.reloadAndRest();
  }

  return (
    <div>
      <Radio.Group onChange={onChange} defaultValue={1} buttonStyle="solid">
        <Radio.Button value={1}>
          完课打卡{`(${userClockNumData.completeClassClockNum || 0})`}
        </Radio.Button>
        <Radio.Button value={2}>
          运动记录{`(${userClockNumData.sportRecordNum || 0})`}
        </Radio.Button>
        <Radio.Button value={3}>
          饮食打卡{`(${userClockNumData.dietClockNum || 0})`}
        </Radio.Button>
        <Radio.Button value={4}>
          睡眠打卡{`(${userClockNumData.sleepClockNum || 0})`}
        </Radio.Button>
        <Radio.Button value={5}>
          体重记录{`(${userClockNumData.weightRecordNum || 0})`}
        </Radio.Button>
        <Radio.Button value={6}>
          自由记录{`(${userClockNumData.freeRecordNum || 0})`}
        </Radio.Button>
      </Radio.Group>

      <ProTable
        style={{ marginTop: '20px' }}
        columns={rightTableColumns}
        actionRef={rightTableRef}
        request={async (params) => {
          const { data, page, code } = await userClockData({
            requestData: {
              userId: userId,
              clockType: clockType,
            },
            page: {
              currentPage: params.current,
              pageSize: params.pageSize,
            },
          });
          if (code !== '00000') {
            return {
              success: false,
            };
          }
          return {
            data: data,
            success: true,
            total: page.count,
          };
        }}
        columnsState={{
          persistenceKey: 'pro-table-singe-demos2',
          persistenceType: 'localStorage',
        }}
        rowKey={(record) => guuid()}
        search={false}
        scroll={{ x: 'max-content' }}
        pagination={{
          defaultPageSize: 10,
        }}
        dateFormatter="string"
        toolBarRender={false}
      />
    </div>
  );
};

export default TrainingView;
